export default "__VITE_ASSET__B8XiGsW4__"